/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Help_CustomInputs */

const en_byoa_help_custom = /** @type {(inputs: Byoa_Help_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For another provider, fill in a service address that follows the OpenAI standard (it usually ends with /v1).`)
};

const id_byoa_help_custom = /** @type {(inputs: Byoa_Help_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk penyedia lain, isi alamat layanan yang sesuai standar OpenAI (biasanya berakhiran /v1).`)
};

/**
* | output |
* | --- |
* | "For another provider, fill in a service address that follows the OpenAI standard (it usually ends with /v1)." |
*
* @param {Byoa_Help_CustomInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_help_custom = /** @type {((inputs?: Byoa_Help_CustomInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Help_CustomInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_help_custom(inputs)
	return en_byoa_help_custom(inputs)
});